import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'
import { Spacer } from 'components/Utility'

const ScrollTopButton: FC = () => {
  const scrollToTop = (): void => {
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    } catch (error) {
      // just a fallback for older browsers
      window.scrollTo(0, 0)
    }
  }

  return (
    <button className={styles.button__scroll} onClick={scrollToTop}>
      <img src={'/icon/white/arrow_top.svg'} alt={'ページトップに戻る'} />
      <Spacer size={4} />
      <span>ページトップに戻る</span>
    </button>
  )
}

export default ScrollTopButton
